import { render, staticRenderFns } from "./QualifikationenReiter.vue?vue&type=template&id=1db5d5c7"
import script from "./QualifikationenReiter.vue?vue&type=script&lang=js"
export * from "./QualifikationenReiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports